// Copyright ©️ 2026 eVolve MEP, LLC

import type { Shipment } from '@evolvemep/api-ts';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { FormModal } from 'components/Mantine/Modals/FormModal';
import { AddShipmentItemsForm } from 'modules/Shop/Shipments/ShipmentDetail/AddShipmentItemsModal/AddShipmentItemsForm';

type Props = ModalRegistryManagedProps & {
  shipment: Shipment;
  onItemsAdded: () => void;
};

export const AddShipmentItemsModal = ({ shipment, onItemsAdded, ...props }: Props) => (
  <FormModal
    title="Add work items"
    type="submit"
    confirmationText="Add items"
    tall
    size="xxl"
    miniHeader={`${shipment.identifier}: ${shipment.name}`}
    startDirty
    {...props}
  >
    <AddShipmentItemsForm shipment={shipment} onItemsAdded={onItemsAdded} />
  </FormModal>
);
